import styled from 'styled-components'

export const Avatar = styled.img`
  max-width: 100%;
  width: ${props => `${props.size}px`};
  height: ${props => `${props.size}px`};
  border-radius: 500px;
`



// WEBPACK FOOTER //
// ./src/styled/avatar.js